<template>
    <div class="container-fluid px-0">

        <div class="col-12 px-0">
            <BaseComponent v-for="(component, index) in components" :key="index" :componentData="component"/>
        </div>

    </div>
</template>

<script>
import BaseComponent from '../components/BaseComponent'
export default {
  name: "FullPageWidth",
  props: ["components", "acf_fc_layout"],
  components:{ BaseComponent}
};
</script>

<style lang="scss" scoped>
</style>
